import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';
import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';
import { BadgeColor } from './badge.types';

@Component({
  selector: 'rt-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.less', './badge-overwrites.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color',
  },
  standalone: true,
  imports: [IconColorDirective, IconComponent, NgTemplateOutlet],
})
export class BadgeComponent {
  @Input() public color: BadgeColor;
  @Input() public iconName: IconName;
  @Input() public iconTmpl?: TemplateRef<any> | null;
  @Input() public iconTmplContext?: Record<string, any> | null;
  @Input() public text: string | number;
}
